"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleRuntimeError = exports.DivisionByZeroError = exports.InterpreterError = void 0;
const runtimeSourceError_1 = require("../errors/runtimeSourceError");
const types_1 = require("../types");
class InterpreterError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(command, message = 'Unexpected evaluation') {
        super(command);
        this.command = command;
        this.message = message;
        this.type = types_1.ErrorType.SYNTAX;
        this.severity = types_1.ErrorSeverity.ERROR;
    }
    explain() {
        return this.message;
    }
    elaborate() {
        return 'There is an evaluation error. This is an internal error - likely, the interpretation of this type of expression is not yet implemented.';
    }
}
exports.InterpreterError = InterpreterError;
class DivisionByZeroError extends runtimeSourceError_1.RuntimeSourceError {
    constructor(command, message = 'Division by zero') {
        super(command);
        this.command = command;
        this.message = message;
        this.type = types_1.ErrorType.RUNTIME;
        this.severity = types_1.ErrorSeverity.ERROR;
    }
    explain() {
        return this.message;
    }
    elaborate() {
        return this.message;
    }
}
exports.DivisionByZeroError = DivisionByZeroError;
function handleRuntimeError(context, error) {
    context.errors.push(error);
    context.runtime.environments = context.runtime.environments.slice(-context.numberOfOuterEnvironments);
    throw error;
}
exports.handleRuntimeError = handleRuntimeError;
//# sourceMappingURL=errors.js.map